export const IFRAME_SEARCH_PARAM_KEYS = {
  FULL3D: 'full3d',
  NO_COOKIE: 'no-cookie',
  NO_SCROLLLOCK: 'no-scrolllock',
  VIEW: 'view',
  IS_3D_COMMERCE: '3dcommerce',
  PREVIEW: 'preview',
  TOKEN: 'token',
  RANDOM_CODE: 'random_code',
  VRAM_LIMIT_PASSED: 'vram_limit_passed',
} as const

export type IframeSearchParamKeys =
  (typeof IFRAME_SEARCH_PARAM_KEYS)[keyof typeof IFRAME_SEARCH_PARAM_KEYS]
